//-- Copyright (c) 2021 TMT Insights Group, LLC
import { JobDetail } from '@/redux/slices/slice_types';
import { JobDetails, TitleBar } from '@/__configs/config_types';
import { LinkButton } from '../../../exports/columnCommonComponents';

const jobDetails: JobDetails = {
  titleBar: (): TitleBar[] => [
    {
      key: 'rally_id',
      label: 'Rally ID',
      render: (data: JobDetail) => {
        return data?.primary_rally_url ? (
          <LinkButton onClick={() => window.open(data?.primary_rally_url, '_blank')}>{data?.version?.rally_id}</LinkButton>
        ) : (
          data?.version?.rally_id || '-'
        );
      }
    },
    {
      key: 'external_id',
      label: 'External ID',
      render: (data: JobDetail) => data.version?.external_id
    }
  ]
};

export default jobDetails;
